import { createContext, useContext, useEffect } from 'react';
import { useAuth } from '@/features/auth';
import { setSentryUser, clearSentryUser } from '@/lib/sentry';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useAuth();

  useEffect(() => {
    const user = auth?.user;
    if (user && (user.uid || user.email)) {
      setSentryUser({ id: user.uid, email: user.email });
    } else {
      clearSentryUser();
    }
  }, [auth?.user]);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuthContext must be used within AuthProvider');
  return ctx;
}
